import microuniversoApi from "app/api/microuniversoApi";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { IColuna } from "app/types/IColuna";
import { IItemOrcamento } from "app/types/IItemOrcamento";
import { Parametro } from "app/types/Parametro";
import { tratamentoErroPadrao } from "app/use-cases";
import { obterPermissao } from "app/use-cases/obterPermissao";
import { obterParametros } from "app/use-cases/parametro/obterParametros";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useEffect, useRef, useState } from "react";
import { substituirItemEmArray } from "substituirItemEmArray";
import { useMenuConsultaProduto } from "../menu-consulta-produtos/useMenuConsultaProduto";
import { renderizarComponentReact } from "../renderizarOuRemoverComponentReact";
import { Separador } from "../separador/Separador";
import { AnaliseGerencialProdutoItem, DadosAnaliseGerencialProdutoItem } from "./AnaliseGerencialProdutoItem";
import { SimuladorPrecoContainerDialog } from "../simulacao-preco/SimuladorPrecoContainerDialog";

export type AnaliseGerencialProdutoItemContainerProps = {
  item: IItemOrcamento,

  onVoltar: () => void,
  passos: Dict<string, () => void>,
  foraOrcamento: boolean
};

export const AnaliseGerencialProdutoItemContainer = (props: AnaliseGerencialProdutoItemContainerProps) => {
  const [dados, setDados] = useState<DadosAnaliseGerencialProdutoItem>();
  const [openModalSimulacaoPreco, setOpenSimulacaoPreco] = useState<boolean>(false)


  const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))
  useMenuConsultaProduto(new Dict(Object.assign({}, props.passos.map)), props.onVoltar, props.item, props.foraOrcamento)

  const onObterDadosAnaliseGerencial = async () => {
    try {
      globalMU.blockUI()
      const resultado = await microuniversoApi.Produto.obterDadosAnaliseGerencial({
        IdProduto: props.item.Codigo,
        IdentificadorOrcamento: props.item.IdentificadorOrcamento
      });
      setDados(resultado);
    }
    catch (e) {
      tratamentoErroPadrao(e);
    }
    finally {
      globalMU.unblockUI();
    }
  }


  const onVoltar = () => {
    //props.onRemover()
    props.onVoltar()
  }

  const onPassoSelecionado = (passo: string) => {
    //props.onRemover()
    passosInterno.current.get(passo)()
  }

  useEffect(() => {
    passosInterno.current.set("Análise Gerencial", () => { renderizarComponentReact(<AnaliseGerencialProdutoItemContainer {...props} />, "conteudo-pagina", true) })
    //atualizarParametros()

    onObterDadosAnaliseGerencial()

  }, [])

  return <>
    <Breadcrumb2Container
      passos={passosInterno.current.keysToList()}
      id="AnaliseGerencialProdutoItemContainer"
      exibirBotaoLimpar={false}
      exibirBotaoVoltar={true}
      onPassoSelecionado={onPassoSelecionado}
      onBotaoVoltarClicado={() => onVoltar()}
    />

    <AnaliseGerencialProdutoItem
      dados={dados}
      onRenderizarConsultaSimulacaoDePreco={() => { setOpenSimulacaoPreco(true) }}
    />

    {openModalSimulacaoPreco &&
      <SimuladorPrecoContainerDialog
        identificadorOrcamento={props.item.IdentificadorOrcamento}
        identificadorItem={props.item.Identificador}
        orcamentoVenda={false}
        somenteLeitura={true}
        onAplicar={async () => { }}
        onCancelar={() => { setOpenSimulacaoPreco(false) }}
      />
    }
  </>
}
